export default class RedirectHelper {
	private _libraryUrl: string;

	constructor(libraryUrl: string) {
		this._libraryUrl = libraryUrl;
	}

	public redirectToLibrary(documentInLibrary: number): void {
		const params = new URLSearchParams();
		params.set('id', `${documentInLibrary}`);
		const url = `${this._libraryUrl}&${params}`;
		this.redirect(url);
	}

	public redirectToEnrichment(documentId: number): void {
		const params = new URLSearchParams();
		params.set('semantic', 'true');
		params.set('id', `${documentId}`);
		const url = `${this._libraryUrl}&${params}`;
		this.redirect(url);
	}

	private redirect(url: string): void {
		const mainWindow = $.iframe.topWindow();
		const isPopup = window.location.search.toLocaleLowerCase().indexOf('popup=yes') >= 0;

		if (
			mainWindow &&
			(typeof mainWindow.NavigateContent === `undefined` || !$.isFunction(mainWindow.NavigateContent)) &&
			!isPopup
		) {
			mainNavigateContent(RFE.MainPage + `?redir=` + encodeURIComponent(url));
			return;
		}

		mainNavigateContent(url);
	}
}
